export default "__VITE_ASSET__DYFkx2Uw__"